import { EnvironmentProviders, inject, makeEnvironmentProviders, provideAppInitializer } from '@angular/core';
import { ProductResource } from '@df/catalog/product/product.resource';
import { GiftcardsProductPlugin } from '@df/module-giftcards/giftcards-product.plugin';

declare module '@df/catalog/product/product' {
    interface Product {
        giftCard: GiftcardsProductPlugin;
    }
}

export function provideDfModuleGiftcards(): EnvironmentProviders {
    return makeEnvironmentProviders([
        provideAppInitializer(() => {
            inject(ProductResource).addPlugin(product => {
                product.giftCard = new GiftcardsProductPlugin(product);
            });
        })
    ]);
}
